$(function () {
  $(".eventcalendar--registration-form").parsley();

  $("#function1, #function2").on("click", function () {
    $(".function3").addClass("hide").find(".form-control").val("");
  });

  $("#function3").on("click", function () {
    $(".function3").removeClass("hide");
  });

  // step 3 - billing address
  $("#billingSame").on("click", function () {
    _billingSame();
  });

  $("#billingOther").on("click", function () {
    _billingOther();
  });

  function _billingSame() {
    $(".billingAddress")
      .addClass("hide")
      .find(".form-control-required")
      .removeAttr("required");
    $(".billingAddress").find(".custom-control-input").prop("checked", false);
    $(".billingAddress").find(".form-control").val("");
  }

  function _billingOther() {
    $(".billingAddress")
      .removeClass("hide")
      .find(".form-control-required")
      .attr("required", "required");
  }
});
